import DtaCalendar from './dtaCalendar';
import {signOutRequest, apiGetRequest, ajaxPostRequest, setgeo, ajaxGetRequest} from './dtaRequest.js';
import {recaptchaExecute, recaptchaInit, removeBlurLoader, setBlurLoader} from './dtaUtils.js';
import {helpPageTours} from "./helpPageTours.js";
import {objectHelper} from "../../../../../resources/app/utils/helpers/objectHelper.js";
import {dateHelper} from "./dateHelper.js";
import {dtaBoostrap} from "./dtaBoostrap.js";
import {postProduct} from "./postProduct.js";

(() => {
    'use strict'

    const form = document.querySelector('.needs-validation');
    const phoneInput = document.querySelector('input.phoneInput');
    const whatsappInput = document.querySelector('input.whatsappInput');
    const csnTreeViews = document.querySelectorAll('.csn-treeview');
    const btnFilterDestination = document.querySelector('.btn.filter-destination');
    const btnSearchFilter = document.querySelector('.btn-search-filter');
    const selectCountry = document.querySelector('select#filter-country');
    const selectCity = document.querySelector('select#filter-city');
    const promoInput = document.getElementById('promocode');
    const promoBtn = document.getElementById('button-apply-promocode');
    let globalParams = null;

    function setPhoneNumber(value) {
        return value.replace(/[^0-9()+\-, ]/g, '');
    }

    if(phoneInput) {
        phoneInput.addEventListener('input', function() {
            this.value = setPhoneNumber(this.value);
        });
    }

    if(whatsappInput) {
        whatsappInput.addEventListener('input', function() {
            this.value = setPhoneNumber(this.value);
        });
    }

    if (promoInput && promoBtn) {
        const updateUI = () => {
            const savedPromo = sessionStorage.getItem('promocode');
            if (savedPromo) {
                promoInput.value = savedPromo;
                promoInput.disabled = true;
                promoBtn.textContent = 'Remove';
                promoBtn.classList.remove('btn_1_md');
                promoBtn.classList.add('btn-danger');
            } else {
                promoInput.value = '';
                promoInput.disabled = false;
                promoBtn.textContent = 'Apply';
                promoBtn.classList.remove('btn-danger');
                promoBtn.classList.add('btn_1_md');
            }
        }

        promoBtn.addEventListener('click', () => {
            const savedPromo = sessionStorage.getItem('promocode');
            if (savedPromo) {
                sessionStorage.removeItem('promocode');
                updateUI();
                window.location.reload();
            } else {
                const promoCode = promoInput.value.trim();
                if (promoCode) {
                    sessionStorage.setItem('promocode', promoCode);
                    updateUI();
                    window.location.reload();
                } else {
                    alert('Please enter a promo code');
                }
            }
        });

        updateUI();
    }

    if(form) {
        if(form.querySelector('button[type="button"]')) {
            form.querySelector('button[type="button"]').addEventListener('click', event => {
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                } else {
                    const nameInput = form.querySelector('input[type="text"][name="name"]');
                    const emailInput = form.querySelector('input[type="email"][name="email"]');
                    const messageInput = form.querySelector('textarea[name="message"]');
                    const alert = form.parentElement.querySelector('.alert');

                    if(alert) {
                        alert.remove();
                    }

                    // Remove all 'invalid-feedback' elements
                    form.querySelectorAll('.invalid-feedback').forEach(el => el.remove());

                    // Remove 'is-invalid' class from all form elements
                    form.querySelectorAll('.is-invalid').forEach(el => el.classList.remove('is-invalid'));

                    setBlurLoader(form);
                    recaptchaExecute().then(token => {
                        ajaxPostRequest(`/enquire-now`, {
                            token: token,
                            name: nameInput.value.trim(),
                            email: emailInput.value.trim(),
                            phone: phoneInput.value.trim(),
                            whatsapp: whatsappInput.value.trim(),
                            message: messageInput.value.trim(),
                            url: window.location.href
                        }).then(data => {
                            const message = `<div class="alert alert-success lh-1-1" role="alert">
                                Your request has been sent successfully. Our customer service team will be in touch shortly to assist you.
                            </div>`;
                            form.classList.remove('was-validated');
                            form.reset();
                            form.parentElement.insertAdjacentHTML('afterbegin', message);
                        }).catch(error => {
                            if(error.status === 422) {
                                if(error.response.data.hasOwnProperty('errors')) {
                                    Object.keys(error.response.data.errors).forEach(field => {
                                        const inputElement = form.querySelector(`[name="${field}"]`);
                                        if (inputElement) {
                                            inputElement.classList.add('is-invalid');
                                            const feedbackElement = document.createElement('div');
                                            feedbackElement.className = 'invalid-feedback';
                                            feedbackElement.textContent = error.response.data.errors[field][0];
                                            inputElement.parentNode.appendChild(feedbackElement);
                                        }
                                    });
                                }
                            } else {
                                const errorMessage = `<div class="alert alert-danger lh-1-1" role="alert">
                                We apologize, your <strong>Enquire Now</strong> submission was unsuccessful. Kindly refresh the page and attempt to send your message again via the <strong>Enquire Now</strong> form.
                            </div>`;
                                form.parentElement.insertAdjacentHTML('afterbegin', errorMessage);
                            }
                        }).finally(() => {
                            removeBlurLoader(form);
                        })
                    });
                }
                form.classList.add('was-validated');
            }, false);
        } else {
            form.addEventListener('submit', event => {
                if (!form.checkValidity()) {
                    event.preventDefault();
                    event.stopPropagation();
                }

                form.classList.add('was-validated')
            }, false);
        }
    }

    if(csnTreeViews.length) {
        const urlParams = new URLSearchParams(window.location.search);
        const countries = urlParams.get('ctry') ? urlParams.get('ctry').split(',').map(item => item.trim()) : [];
        const cities = urlParams.get('city') ? urlParams.get('city').split(',').map(item => item.trim()) : [];
        const nestedUpTreeView = (_checkbox)=>{
            const ulParent = _checkbox.closest('ul');
            if(!ulParent.classList.contains('csn-treeview')) {
                const checkParent = ulParent.previousElementSibling.querySelector('input[type="checkbox"]');
                const checkChildren = ulParent.querySelectorAll('input[type="checkbox"]');
                const checked = ulParent.querySelectorAll('input[type="checkbox"]:checked');

                checkParent.checked = (checkChildren.length === checked.length);
                checkParent.classList.remove('check-marked');
                if(!checkParent.checked && checked.length) {
                    checkParent.classList.add('check-marked');
                }
                nestedUpTreeView(checkParent);
            }
        }
        const nestedDownTreeView = (_checkbox)=>{
            const childTreeView = _checkbox.closest('li').querySelector('.ctrv-children');
            if(childTreeView) {
                childTreeView.querySelectorAll('input[type="checkbox"]').forEach(childCheckbox => {
                    childCheckbox.checked = _checkbox.checked;
                });
            }
        }

        csnTreeViews.forEach(treeView => {
            if(countries.length) {
                countries.forEach(country => {
                    const checkbox = treeView.querySelector(`input[type="checkbox"][value="${country}"]`);
                    if(checkbox) {
                        checkbox.checked = true;
                        nestedDownTreeView(checkbox);
                    }
                });
            }
            if(cities.length) {
                cities.forEach(city => {
                    const checkbox = treeView.querySelector(`input[type="checkbox"][value="${city}"]`);
                    if(checkbox) {
                        checkbox.checked = true;
                        nestedUpTreeView(checkbox);
                    }
                });
            }
            treeView.querySelectorAll('a.ctrv-collapsed').forEach(element => {
                element.addEventListener('click', event => {
                    const childTreeView = event.target.closest('li').querySelector('.ctrv-children');
                    const target = event.target.classList.contains('ti')?event.target : event.target.querySelector('.ti');
                    if(target.classList.contains('ti-square-minus-filled')) {
                        target.classList.remove('ti-square-minus-filled');
                        target.classList.add('ti-square-plus');
                        if(childTreeView) {
                            childTreeView.style.display = 'none';
                        }
                    } else {
                        target.classList.remove('ti-square-plus');
                        target.classList.add('ti-square-minus-filled');
                        if(childTreeView) {
                            childTreeView.style.display = 'block';
                        }
                    }
                });
            });
            treeView.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                checkbox.addEventListener('change', event => {
                    nestedDownTreeView(event.target);
                    nestedUpTreeView(event.target);
                });
            });
        });
    }


    if(btnFilterDestination) {
        btnFilterDestination.addEventListener('click', event => {
            event.preventDefault();
            const parentElement = event.target.closest('.filter_type');
            if(parentElement) {
                const treeView = parentElement.querySelector('.csn-treeview.filter-destination');
                if(treeView) {
                    let countryStr = '';
                    let cityStr = '';
                    let ulParent, checkParent;
                    const currentUrl = new URL(window.location.href);
                    const params = new URLSearchParams(currentUrl.search);

                    treeView.querySelectorAll('input[type="checkbox"]:checked').forEach(checkbox => {
                        if(checkbox.dataset.paramName==='country') {
                            countryStr += (countryStr?',':'') + checkbox.value;
                        } else if(checkbox.dataset.paramName==='city') {
                            ulParent = checkbox.closest('ul');
                            if(ulParent) {
                                checkParent = ulParent.previousElementSibling.querySelector('input[type="checkbox"]');
                                if(checkParent) {
                                    if(!checkParent.checked) {
                                        cityStr += (cityStr?',':'') + checkbox.value;
                                    }
                                }
                            }
                        }
                    });

                    params.delete('page');

                    if (countryStr) {
                        params.set('ctry', countryStr);
                    } else {
                        params.delete('ctry');
                    }

                    if (cityStr) {
                        params.set('city', cityStr);
                    } else {
                        params.delete('city');
                    }

                    currentUrl.search = params.toString();
                    window.location.href = currentUrl.toString();
                }
            }
        });
    }

    if(btnSearchFilter) {
        btnSearchFilter.addEventListener('click', event => {
            event.preventDefault();
            const selectCategory = document.querySelector('select#filter-category');
            if(selectCategory) {
                const currentUrl = new URL(selectCategory.value);
                const params = new URLSearchParams(window.location.search);
                const country = selectCountry ? selectCountry.value : '';
                const city = selectCity ? selectCity.value : '';

                params.delete('page');
                if(country) {
                    params.set('ctry', country);
                } else {
                    params.delete('ctry');
                }

                if(city) {
                    params.set('city', city);
                } else {
                    params.delete('city');
                }

                currentUrl.search = params.toString();
                window.location.href = currentUrl.toString();
            }
        });
    }

    if(selectCountry && selectCity) {
        const filterCities = () => {
            const country = selectCountry.value;
            const cityOptions = selectCity.querySelectorAll('option');
            let firstVisibleCity = '';

            cityOptions.forEach(option => {
                if (option.value === '') {
                    option.style.display = 'block';
                } else {
                    if (country === '' || option.dataset.country === country) {
                        option.style.display = 'block';
                        if(!firstVisibleCity) firstVisibleCity = option.value;
                    } else {
                        option.style.display = 'none';
                        if(option.selected) {
                            selectCity.value = '';
                        }
                    }
                }
            });
        };

        selectCountry.addEventListener('change', filterCities);
        filterCities();
    }

    recaptchaInit().then(response => {
        const departureDateCalendar = document.querySelector('.departure-calendar');
        const departureDateButtons = document.querySelectorAll('.departure-date .btn[data-departure]');
        const fhCalendar = document.querySelector('.fh-calendar');
        const elHelpPageTours = document.querySelector('.help-page-tours');

        if(departureDateButtons.length > 0) {
            departureDateButtons.forEach(btn => {
                btn.addEventListener('click', event => {
                    event.preventDefault();
                    const targetUrl = window.location.origin + window.location.pathname;
                    const date = event.target.getAttribute('data-departure');
                    if (date && dateHelper.isDate(date) && !event.target.classList.contains('purchase')) {
                        const ddActiveBtn = document.querySelector('.departure-date .btn.purchase[data-departure]');
                        const strDate = dateHelper.formatDate(date, 'YYYYMMDD');
                        const loaderEls = [event.target.parentElement];
                        const priceList = document.querySelector('.price-list');
                        let isGet = true;

                        if(priceList) {
                            if(priceList.classList.contains('price-list')) {
                                document.querySelectorAll('.price-list > .card').forEach(el => {
                                    loaderEls.push(el);
                                });
                            } else {
                                loaderEls.push(priceList);
                            }
                        }

                        if(globalParams.hasOwnProperty('productPrices')) {
                            if(ddActiveBtn) {
                                ddActiveBtn.classList.remove('purchase');
                            }
                            event.target.classList.add('purchase');

                            if(globalParams.productPrices.hasOwnProperty(strDate)) {
                                if(dateHelper.isBeforeDate(new Date(), globalParams.productPrices[strDate].expired)) {
                                    isGet = false;
                                    postProduct.setPriceItems(globalParams, strDate);
                                }
                            }

                            if (isGet) {
                                setBlurLoader(loaderEls);
                            recaptchaExecute().then(token => {
                                    const payload = {
                                        date: date,
                                        token: token
                                    };

                                    const savedPromo = sessionStorage.getItem('promocode');
                                    if (savedPromo) {
                                        payload.promocode = savedPromo;
                                    }

                                    ajaxPostRequest(`${targetUrl}/prices`, payload).then(data => {
                                        if(!objectHelper.isEmptyObject(data)) {
                                            globalParams.productPrices[strDate] = {
                                                expired: dateHelper.addMinute(new Date(), 5).toDate(),
                                                items : data
                                            }
                                            postProduct.setPriceItems(globalParams, strDate);
                                        }
                                    }).catch(error => {
                                        console.error('Failed to load prices:', error);
                                    })
                                        .finally(() => {
                                            removeBlurLoader(loaderEls);
                                        });
                                }).catch(error => {
                                    console.error('reCAPTCHA execution failed:', error);
                                    removeBlurLoader(loaderEls);
                                });
                            }
                        }
                    }
                })
            })
        }

        const getTotalCalendar = (calendarEl) => {
            const isSidebar = calendarEl && calendarEl.closest('#sidebar');
            const isXlOrUp = dtaBoostrap.isColumnXlOrUp();
            const isMd = dtaBoostrap.isColumnMd();

            if (isSidebar) {
                return isMd ? 2 : 1;
            }
            return (isXlOrUp || isMd) ? 2 : 1;
        };

        if(departureDateCalendar && response.success) {
            const calendarClass = new DtaCalendar(departureDateCalendar, {
                totalCalendar: getTotalCalendar(departureDateCalendar),
                events: {
                    afterInit: (event) => {
                        const targetUrl = window.location.origin + window.location.pathname;
                        if(elHelpPageTours) {
                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });
                        }

                        setBlurLoader(departureDateCalendar.parentElement);
                        recaptchaExecute().then(token => {
                            const payload = {
                                early: true,
                                tmonth: event.thisObj.options.totalCalendar,
                                token: token
                            };

                            const savedPromo = sessionStorage.getItem('promocode');
                            if (savedPromo) {
                                payload.promocode = savedPromo;
                            }

                            ajaxPostRequest(`${targetUrl}/dates`, payload).then(data => {
                                if(!objectHelper.isEmptyObject(data)) {
                                    if(data.hasAvailableDates === false || (objectHelper.isEmptyObject(data.items) && (!data.startDate || (Array.isArray(data.disableDates) && data.disableDates.includes(data.startDate))))) {
                                        const calendarContainer = departureDateCalendar.closest('#booking-calendar') || departureDateCalendar.closest('.departure-date');
                                        if (calendarContainer) {
                                            calendarContainer.classList.add('d-none');
                                        }
                                        const bookingNav = document.querySelector('.tour-nav-booking')?.closest('.tour-nav-item');
                                        if (bookingNav) {
                                            bookingNav.classList.add('d-none');
                                        }
                                        const mobileTopBar = document.getElementById('mobileTopBookingBar');
                                        if (mobileTopBar) {
                                            mobileTopBar.classList.add('d-none');
                                        }
                                        return;
                                    }

                                    if(data.hasOwnProperty('startDate') && data.hasOwnProperty('disableDates')) {
                                        const productPrices = {};
                                        const loadMonths = {};

                                        if(!objectHelper.isEmptyObject(data.items)) {
                                            productPrices[dateHelper.formatDate(data.startDate, 'YYYYMMDD')] = {
                                                expired: dateHelper.addMinute(new Date(), 5).toDate(),
                                                items : data.items
                                            }
                                        }

                                        loadMonths[dateHelper.formatDate(data.startDate, 'YYYYMM')] = dateHelper.addMinute(new Date(), 5).toDate();
                                        event.thisObj.setOptions({
                                            readOnly: false,
                                            minDate: data.startDate,
                                            maxDate: data.lastDate,
                                            disableDates: data.disableDates,
                                            extraParams: {
                                                loadMonths: loadMonths,
                                                productPrices: productPrices
                                            }
                                        });
                                        event.thisObj.selectDate = dateHelper.toDate(data.startDate);
                                        event.thisObj.resetCalendar();
                                        postProduct.setPriceItems(event.thisObj.options.extraParams, dateHelper.formatDate(data.startDate, 'YYYYMMDD'));
                                        setTimeout(()=>{
                                            if(elHelpPageTours) {
                                                const _helpPageTours = helpPageTours();
                                                if(_helpPageTours) {
                                                    _helpPageTours.start().then(r => {});
                                                }
                                            }
                                        }, 1000);
                                    }
                                }
                            }).catch(error => {
                                console.error('Failed to load initial dates:', error);
                                // Fallback: try to reset calendar or show error
                                event.thisObj.setReadOnly(false);
                            }).finally(() => {
                                removeBlurLoader(departureDateCalendar.parentElement);
                            });
                        }).catch(error => {
                            console.error('reCAPTCHA execution failed:', error);
                            removeBlurLoader(departureDateCalendar.parentElement);
                            // Even if reCAPTCHA fails, we might want to let them interact,
                            // though subsequent requests might fail.
                            event.thisObj.setReadOnly(false);
                        });
                    },
                    next: (event) => {
                        if(!event.thisObj.options.readOnly) {
                            let isGetDisableDates = true;
                            const targetUrl = window.location.origin + window.location.pathname;
                            const yearMonth = dateHelper.formatDate(new Date(event.params.year, event.params.month - 1), 'YYYYMM');

                            if(event.thisObj.options.extraParams.loadMonths.hasOwnProperty(yearMonth)) {
                                if(dateHelper.isBeforeDate(new Date(), event.thisObj.options.extraParams.loadMonths[yearMonth])) {
                                    isGetDisableDates = false;
                                }
                            } else {
                                event.thisObj.setReadOnly(true);
                            }

                            if(isGetDisableDates) {
                                setBlurLoader(departureDateCalendar.parentElement);
                                recaptchaExecute().then(token => {
                                    const payload = {
                                        year: event.params.year,
                                        month: event.params.month,
                                        tmonth: event.thisObj.options.totalCalendar,
                                        token: token
                                    };

                                    const savedPromo = sessionStorage.getItem('promocode');
                                    if (savedPromo) {
                                        payload.promocode = savedPromo;
                                    }

                                    ajaxPostRequest(`${targetUrl}/dates`, payload).then(data => {
                                        if(Array.isArray(data)) {
                                            event.thisObj.pushDisableDates(data);
                                        }
                                        event.thisObj.setReadOnly(false);
                                        event.thisObj.options.extraParams.loadMonths[yearMonth] = dateHelper.addMinute(new Date(), 5).toDate();
                                    }).catch(error => {
                                        console.error('Failed to load dates for month:', error);
                                        event.thisObj.setReadOnly(false);
                                    }).finally(() => {
                                        removeBlurLoader(departureDateCalendar.parentElement);
                                    });
                                }).catch(error => {
                                    console.error('reCAPTCHA execution failed:', error);
                                    removeBlurLoader(departureDateCalendar.parentElement);
                                    event.thisObj.setReadOnly(false);
                                });
                            }
                        }
                    },
                    previous: (event) => { calendarClass.options.events.next(event) },
                    change: (event) => { calendarClass.options.events.next(event) },
                    select: (event) => {
                        if(!event.thisObj.options.readOnly) {
                            let isGet = true;
                            const strDate = dateHelper.formatDate(event.params.date, 'YYYYMMDD');
                            if(event.thisObj.options.extraParams.productPrices.hasOwnProperty(strDate)) {
                                if(dateHelper.isBeforeDate(new Date(), event.thisObj.options.extraParams.productPrices[strDate].expired)) {
                                    isGet = false;
                                }
                            }

                            if(isGet) {
                                const targetUrl = window.location.origin + window.location.pathname;
                                let priceList = document.querySelector('.price-list');
                                if(!priceList) {
                                    priceList = document.querySelector((dtaBoostrap.isColumnMd() || dtaBoostrap.isColumnSm() ? '.addons.right-price-list' : '.addons.left-price-list'));
                                    if(priceList) {
                                        priceList = priceList.querySelector('.card-body');
                                    }
                                }
                                if(priceList) {
                                    const loaderEls = [departureDateCalendar.parentElement];
                                    if(priceList.classList.contains('price-list')) {
                                        document.querySelectorAll('.price-list > .card').forEach(el => {
                                            loaderEls.push(el);
                                        });
                                    } else {
                                        loaderEls.push(priceList);
                                    }

                                    setBlurLoader(loaderEls);
                                    recaptchaExecute().then(token => {
                                        const payload = {
                                            date: dateHelper.formatDate(event.params.date, 'YYYY-MM-DD'),
                                            tmonth: event.thisObj.options.totalCalendar,
                                            token: token
                                        };

                                        const savedPromo = sessionStorage.getItem('promocode');
                                        if (savedPromo) {
                                            payload.promocode = savedPromo;
                                        }

                                        ajaxPostRequest(`${targetUrl}/prices`, payload).then(data => {
                                            if(!objectHelper.isEmptyObject(data)) {
                                                event.thisObj.options.extraParams.productPrices[strDate] = {
                                                    expired: dateHelper.addMinute(new Date(), 5).toDate(),
                                                    items : data
                                                }
                                                removeBlurLoader(loaderEls);
                                                postProduct.setPriceItems(event.thisObj.options.extraParams, strDate);
                                            }
                                        }).catch(error => {
                                            console.error('Failed to load prices for selected date:', error);
                                        }).finally(() => {
                                            removeBlurLoader(loaderEls);
                                        });
                                    }).catch(error => {
                                        console.error('reCAPTCHA execution failed:', error);
                                        removeBlurLoader(loaderEls);
                                    });
                                }
                            } else {
                                postProduct.setPriceItems(event.thisObj.options.extraParams, strDate);
                            }
                        }
                    },
                    beforeResize(event) {
                        event.thisObj.options.totalCalendar = getTotalCalendar(event.thisObj.initElement);
                    },
                    changeTotalCalendar(event) {
                        if(!event.thisObj.options.readOnly) {
                            event.thisObj.options.extraParams.loadMonths = {};
                            event.thisObj.options.events.next(event);
                        }
                    }
                }
            });
        // } else if (fhCalendar) {
        } else if (response.success) {
            const targetUrl = window.location.origin + window.location.pathname;

            if(elHelpPageTours) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }

            recaptchaExecute().then(token => {
                const payload = {
                    token: token
                };

                const savedPromo = sessionStorage.getItem('promocode');
                if (savedPromo) {
                    payload.promocode = savedPromo;
                }

                ajaxPostRequest(`${targetUrl}/prices`, payload).then(data => {
                    if(!objectHelper.isEmptyObject(data)) {
                        const extraParams = { productPrices: {} };
                        const strDate = dateHelper.formatDate(data.date, 'YYYYMMDD');
                        const btnDepartureDate = document.querySelector(`.departure-date .btn[data-departure="${data.date}"]`);
                        extraParams.productPrices[strDate] = {
                            expired: dateHelper.addMinute(new Date(), 5).toDate(),
                            items : data.items
                        }
                        postProduct.setPriceItems(extraParams, strDate);
                        globalParams = extraParams;
                        if(btnDepartureDate) {
                            btnDepartureDate.classList.add('purchase');
                        }
                        setTimeout(()=>{
                            if(elHelpPageTours) {
                                const _helpPageTours = helpPageTours();
                                if(_helpPageTours) {
                                    _helpPageTours.start().then(r => {});
                                }
                            }
                        }, 1000);
                    }
                }).catch(error => {
                    console.error('Failed to load prices (non-calendar):', error);
                });
            }).catch(error => {
                console.error('reCAPTCHA execution failed (non-calendar):', error);
            });
        }
    });

    setTimeout(()=>{
        const elul = window.document.querySelector('#menu ul');
        const mmul = window.document.querySelector('#mm-menu #mm-0 ul.mm-listview');
        const setSignIn=(elul)=>{
            let newel;

            if(import.meta.env.VITE_REGISTER==='true') {
                newel = window.document.createElement('li');
                newel.innerHTML = `<span><a href="${window.location.origin}/app/register">Register</a></span>`;
                newel.classList.add('mm-register');
                elul.appendChild(newel);
            }

            newel = window.document.createElement('li');
            newel.innerHTML = `<span><a href="${window.location.origin}/app/login">Sign In</a></span>`;
            newel.classList.add('mm-login');
            elul.appendChild(newel);
        };
        const setAccount=(elul)=>{
            let newel;
            newel = window.document.createElement('li');
            newel.innerHTML = `<span><a href="${window.location.origin}/app">My Account</a></span>`;
            newel.classList.add('mm-account');
            elul.appendChild(newel);
            newel = window.document.createElement('li');
            newel.innerHTML = `<span><a href="javascript:void(0)">Sign Out</a></span>`;
            newel.classList.add('mm-logout');
            elul.appendChild(newel);
            newel.querySelector('a').addEventListener('click', async event => {
                await signOutRequest().then(()=>{
                    window.location.reload();
                });
            });
        };

        if(elul) {
            apiGetRequest('/user/auth').then(data=>{
                setAccount(elul);
                if(mmul) {
                    setAccount(mmul);
                }

                apiGetRequest('/v1/booking/shopping-cart/bucket').then(data=>{
                    if(data.success) {
                        const cartIcon = window.document.querySelector('.cart-menu-btn');
                        if(cartIcon) {
                            const cartCount = cartIcon.querySelector('strong');
                            if(cartCount) {
                                cartCount.innerText = data.total;
                            }
                            if (data.scart_id) {
                                cartIcon.setAttribute('href', `/booking/shopping-cart/${data.scart_id}`);
                            }
                        }
                    }
                });
            }).catch(error=>{
                setSignIn(elul);
                if(mmul) {
                    setSignIn(mmul);
                }

                ajaxGetRequest('/booking/shopping-cart/bucket').then(data=>{
                    if(data.success) {
                        const cartIcon = window.document.querySelector('.cart-menu-btn');
                        if(cartIcon) {
                            const cartCount = cartIcon.querySelector('strong');
                            if(cartCount) {
                                cartCount.innerText = data.total;
                            }
                            if (data.scart_id) {
                                cartIcon.setAttribute('href', `/booking/shopping-cart/${data.scart_id}`);
                            }
                        }
                    }
                });
            });
        }


    }, 250);

})()
